import type { ReactNode } from 'react';

import type { Role } from '@/entities/user';
import { useHasRole } from '@/shared/hooks/useRole';

export interface RoleGateProps {
  allow: readonly Role[];
  fallback?: ReactNode;
  children: ReactNode;
}

export function RoleGate({ allow, fallback = null, children }: RoleGateProps) {
  const allowed = useHasRole(...allow);
  return <>{allowed ? children : fallback}</>;
}
